import React from "react";
import {Card, CardBody, CardHeader} from "reactstrap";

const cle = id => "carte-repliable-" + id;

/** Dernier choix de la personne (« ouvert » ou « fermé »), gardé dans ce navigateur ; null si aucun ou si le stockage est indisponible. */
function lire(id) {
    try {
        const v = window.localStorage.getItem(cle(id));
        return v === "ouvert" ? true : v === "ferme" ? false : null;
    } catch (e) {
        return null;
    }
}

function ecrire(id, ouvert) {
    try {
        window.localStorage.setItem(cle(id), ouvert ? "ouvert" : "ferme");
    } catch (e) {
        // stockage indisponible : la carte fonctionne quand même, sans mémoire
    }
}

/**
 * Carte dont le contenu se déroule en cliquant sur le titre, pour tenir moins de place. Le contenu n'est affiché (donc ses
 * aperçus animés ne tournent) que lorsque la carte est ouverte. Le dernier choix est retenu dans ce navigateur.
 *
 * @param id        identifiant stable, pour retenir le choix
 * @param titre     titre de la carte
 * @param ouvert    état au premier affichage si rien n'est retenu (replié par défaut)
 * @param style     style du corps de la carte (facultatif)
 */
export default function CarteRepliable({id, titre, ouvert = false, className, styleCorps, children}) {
    const [deroule, setDeroule] = React.useState(() => {
        const retenu = lire(id);
        return retenu === null ? ouvert : retenu;
    });
    const basculer = () => {
        setDeroule(!deroule);
        ecrire(id, !deroule);
    };

    return (
        <Card className={className}>
            <CardHeader role="button" tabIndex={0} aria-expanded={deroule} onClick={basculer}
                        onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); basculer(); } }}
                        style={{cursor: "pointer", userSelect: "none"}}>
                <h3 className="mb-0 d-flex justify-content-between align-items-center">
                    {titre}
                    <span className="text-muted d-flex align-items-center" style={{fontSize: ".8rem", fontWeight: 400}}>
                        {deroule ? "Cliquer pour replier" : "Cliquer pour dérouler"}
                        <span className="ml-2 d-inline-flex justify-content-center align-items-center border rounded-circle"
                              style={{width: 26, height: 26, fontSize: ".9rem"}} aria-hidden="true">{deroule ? "▴" : "▾"}</span>
                    </span>
                </h3>
            </CardHeader>
            {deroule && <CardBody style={styleCorps}>{children}</CardBody>}
        </Card>
    );
}
